import { AxiosHttpClient } from './AxiosHttpClient';
import { IHttpClient } from './IHttpClient';
import { HeadersGetter } from './IHttpClientConfig';
import { IHttpClientFactory } from './IHttpClientFactory';
import axios from 'axios';
export class AxiosHttpClientFactory implements IHttpClientFactory {
  constructor(private headersGetter?: HeadersGetter) {}

  createClient(): IHttpClient {
    const config = {
      headersGetter: this.headersGetter,
    };
    return new AxiosHttpClient(axios, config);
  }

  createClientWithBaseUrl(baseUrl: string): IHttpClient {
    const config = {
      baseUrl,
      headersGetter: this.headersGetter,
    };
    return new AxiosHttpClient(axios, config);
  }
}
